import {
  Tooltip,
  Skeleton,
  CircularProgress,
  Button,
  ButtonGroup,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import {
  downloadUnitPerformanceReport,
  getSubordinateContracts,
} from "../../../store/rbm/actions";
import RBMPageHeader from "../components/RBMPageHeader";
import SubordinateCard from "../components/SubordinateCard";
import axios from "axios";
import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import GroupIcon from "@mui/icons-material/Group";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PillTabs from "../../common/components/PillTabs";
import PendingReports from "./PendingReports";
import MySubordinateContracts from "./MySubordinateContracts";

const TAB_ICONS = {
  pendingReports: <AssignmentIcon fontSize="small" />,
  active: <GroupIcon fontSize="small" />,
  exited: <PersonOffIcon fontSize="small" />,
  pendingCompetencies: <FactCheckIcon fontSize="small" />,
};

const MySubordinates = (props) => {
  const {
    loading,
    user,
    getSubordinateContracts,
    subordinateContracts,
    selectedFiscalYear,
    downloadUnitPerformanceReport,
    subordinatePendingReports,
    selectedPlanningEntityId,
  } = props;

  useEffect(() => {
    document.title = "IPPIS - RBM My Subordinates";
  });

  const [tabs, setTabs] = useState([]);
  const [currentTab, setCurrentTab] = useState("pending-reports");

  // to be removed
  const [subordinatesSummary, setSubordinatesSummary] = useState({
    numOfSubordinates: 0,
    numOfActivities: 0,
    ontrackActivities: 0,
    dueActivities: 0,
    reportedActivities: 0,
    scoredActivities: 0,
    rejectedActivities: 0,
    targetAchieved: 0,
    score: 0,
    unContracted: 0,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(5);
  const [isNotActive, setIsNotActive] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loader, setLoader] = useState(false);
  const getNo = (idToSearch) => {
    return subordinateContracts.findIndex(({ id }) => id === idToSearch);
  };
  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);

    const query = {
      isNotActive,
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getSubordinateContracts(query, setTotalRecords, setLoader);
  };
  // end - to be removed

  const next = useMemo(() => {
    const n = (v) => (Number.isFinite(v) ? v : parseInt(v, 10)) || 0;

    const actReports = n(subordinatePendingReports?.forActiveReports);
    const actCompNE = n(
      subordinatePendingReports?.forActiveCompetencyNotEvaluated
    );
    const exReports = n(subordinatePendingReports?.forExitedReports);
    const exCompNE = n(
      subordinatePendingReports?.forExitedCompetencyNotEvaluated
    );

    const pickSummary = (reports, compNE) => {
      if (reports > 0) return { value: reports, color: "danger" };
      if (compNE > 0) return { value: compNE, color: "warning" };
      return { value: 0, color: undefined };
    };

    const activePick = pickSummary(actReports, actCompNE);
    const exitedPick = pickSummary(exReports, exCompNE);

    return [
      {
        value: "pending-reports",
        label: "Pending Reports",
        icon: TAB_ICONS.pendingReports,
        summary: n(subordinatesSummary?.reportedActivities),
        disabled: false,
      },
      {
        value: "active-subordinates",
        label: "Active Subordinates",
        icon: TAB_ICONS.active,
        summary: activePick.value,
        summaryColor: activePick.color,
        disabled: false,
      },
      {
        value: "exited-subordinates",
        label: "Exited Subordinates",
        icon: TAB_ICONS.exited,
        summary: exitedPick.value,
        summaryColor: exitedPick.color,
        disabled: false,
      },
      {
        value: "pending-competencies",
        label: "Pending Competencies",
        icon: TAB_ICONS.pendingCompetencies,
        summary: actCompNE + exCompNE,
        disabled: false,
      },
    ];
  }, [subordinatePendingReports]);

  useEffect(() => {
    let changed = false;
    if (tabs.length !== next.length) {
      changed = true;
    } else {
      for (let i = 0; i < next.length; i++) {
        const a = tabs[i] || {};
        const b = next[i] || {};
        if (a.summary !== b.summary || a.summaryColor !== b.summaryColor) {
          changed = true;
          break;
        }
      }
    }
    if (changed) setTabs(next);
  }, [next, tabs]);

  const onSearch = (term) => {
    setSearchTerm(term);

    if (term === "") {
      const _currentPage = 1;
      setCurrentPage(_currentPage);

      const _searchTerm = "";
      setSearchTerm(_searchTerm);

      const query = {
        isNotActive,
        searchTerm: _searchTerm,
        page: _currentPage,
        size: itemPerPage,
      };

      getSubordinateContracts(query, setTotalRecords, setLoader);
    }
  };

  return (
    <>
      <div className="row no-gutter justify-content-center">
        <div className="col-12 col-lg-11 px-0 px-md-3">
          <h6 className="d-flex justify-content-between">
            <span className="d-flex align-items-center">
              <span className="text-uppercase">My Subordinates</span>

              {!!subordinatesSummary.unContracted && (
                <Tooltip title="View">
                  <span
                    onClick={() => {
                      const _currentPage = 1;
                      setCurrentPage(_currentPage);

                      const _searchTerm =
                        searchTerm === "uncontracted" ? "" : "uncontracted";
                      setSearchTerm(_searchTerm);

                      const query = {
                        searchTerm: _searchTerm,
                        page: _currentPage,
                        size: itemPerPage,
                      };

                      getSubordinateContracts(
                        query,
                        setTotalRecords,
                        setLoader
                      );
                    }}
                    className={`badge text-danger text-uppercase ml-2`}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    {searchTerm !== "uncontracted" && (
                      <CheckBoxOutlineBlankOutlinedIcon />
                    )}
                    {searchTerm === "uncontracted" && <CheckBoxOutlinedIcon />}
                    {subordinatesSummary.unContracted} Not contracted
                  </span>
                </Tooltip>
              )}
            </span>
          </h6>
          <div className="mb-3">
            <RBMPageHeader
              labels={[
                {
                  title: "Subordinates",
                  value: subordinatesSummary.numOfSubordinates || 0,
                  type: "number",
                },
                {
                  title: "ITEMS",
                  value: subordinatesSummary.numOfActivities || 0,
                  type: "number",
                },
                {
                  title: "Ontrack",
                  value: subordinatesSummary.ontrackActivities || 0,
                  type: "number",
                },
                {
                  title: "Due",
                  value: subordinatesSummary.dueActivities || 0,
                  type: "number",
                },
                {
                  title: "Reported",
                  value: subordinatesSummary.reportedActivities || 0,
                  type: "number",
                },
                {
                  title: "Scored",
                  value: subordinatesSummary.scoredActivities || 0,
                  type: "number",
                },
                {
                  title: "Rejected",
                  value: subordinatesSummary.rejectedActivities || 0,
                  type: "number",
                },
                {
                  title: "Target achieved",
                  value: (subordinatesSummary.targetAchieved || 0).toFixed(2),
                  type: "percentage",
                },
              ]}
              progress={{
                title: "PROGRESS",
                value: subordinatesSummary.score || 0,
              }}
              buttons={[
                {
                  fun: () =>
                    downloadUnitPerformanceReport(user.employments[0].unitId),
                  title: "DOWNLOAD",
                },
              ]}
              disabled={loading}
              loading={loading}
            />
          </div>
          <PillTabs
            items={tabs}
            value={currentTab}
            onChange={setCurrentTab}
            className="mb-3"
          />
          <div className="rbm-shadow rounded px-4 py-3">
            {currentTab === "pending-reports" ? <PendingReports /> : null}
            {["active-subordinates", "exited-subordinates"].includes(
              currentTab
            ) ? (
              <MySubordinateContracts
                isNotActive={
                  currentTab === "exited-subordinates" ? true : false
                }
              />
            ) : null}

            {/* <div className="form-group">
              <input
                type="text"
                className="form-control"
                value={searchTerm}
                id="filter"
                placeholder="Search..."
                onChange={(e) => onSearch(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    const query = {
                      searchTerm: searchTerm,
                      page: currentPage,
                      size: itemPerPage,
                    };

                    getSubordinateContracts(query, setTotalRecords, setLoader);
                  }
                }}
              />
            </div> */}

            {/* {subordinateContracts &&
              subordinateContracts.map((subordinate) => (
                <SubordinateCard
                  key={subordinate.id + subordinate.contractId || ""}
                  index={getNo(subordinate.id)}
                  subordinate={subordinate}
                  refreshOnChange={() => {
                    const query = {
                      searchTerm: searchTerm,
                      page: currentPage,
                      size: itemPerPage,
                    };

                    getSubordinateContracts(query, setTotalRecords, setLoader);
                  }}
                />
              ))} */}

            {/* {!subordinateContracts[0] && loading && (
              <div>
                <Skeleton
                  variant="rectangular"
                  className="mb-3 mt-2"
                  height={118}
                />
                <Skeleton variant="rectangular" className="mb-3" height={96} />
                <Skeleton variant="rectangular" className="mb-3" height={96} />
                <Skeleton variant="rectangular" className="mb-3" height={96} />
              </div>
            )} */}

            {/* {!subordinateContracts[0] && !loading && (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container">
                  <p className="lead">No subordinate found.</p>
                </div>
              </div>
            )} */}

            {/* <div
              className="d-flex justify-content-center  align-items-center"
              style={{ overflow: "hidden" }}
            >
              <div className="mt-3">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={
                    <>
                      <span className="pr-1 d-none d-md-inline">Next</span>
                      <i className="fas fa-angle-double-right"></i>
                    </>
                  }
                  previousLabel={
                    <>
                      <i className="fas fa-angle-double-left"></i>
                      <span className="pl-1  d-none d-md-inline">Previous</span>
                    </>
                  }
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                  onPageChange={handlePageClick}
                  pageCount={Math.ceil(totalRecords / itemPerPage)}
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                  previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                  nextLinkClassName="btn btn-outline-info btn-sm ml-1"
                  activeLinkClassName="active"
                />
              </div>

              {!!subordinateContracts.length && (
                <select
                  className="custom-select custom-select-sm mr-3 ml-2"
                  style={{ width: "100px" }}
                  value={itemPerPage}
                  onChange={(event) => {
                    const itemPerPage = +event.target.value;
                    setItemPerPage(itemPerPage);
                    const query = {
                      searchTerm: searchTerm,
                      page: currentPage,
                      size: itemPerPage,
                    };
                    getSubordinateContracts(query, setTotalRecords, setLoader);
                  }}
                >
                  {[5, 10, 50].map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
              )}
            </div> */}
          </div>
        </div>
      </div>

      <div
        className={`page-loading-void position-fixed ${
          loader && !!subordinateContracts[0] ? "d-block" : "d-none"
        }`}
      >
        {loader && (
          <CircularProgress
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
              color: "rgb(7, 142, 206)",
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
            size={40}
            thickness={4}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  loading,
  user,
  env,
  subordinateContracts,
  selectedFiscalYear,
  subordinatePendingReports,
  selectedPlanningEntityId,
}) => {
  return {
    loading,
    user,
    env,
    subordinateContracts,
    selectedFiscalYear,
    subordinatePendingReports,
    selectedPlanningEntityId,
  };
};

export default connect(mapStateToProps, {
  getSubordinateContracts,
  downloadUnitPerformanceReport,
})(MySubordinates);
